<template>
  <modal
    name="drive-deadline"
    height="auto"
    width="500px"
    :scrollable="true"
    :adaptive="true"
    class="modal-dialog"
    @closed="$emit('close')"
  >
    <div class="modal-content o-common-modal-content">
      <div class="modal-header text-center">
        <button type="button" class="close" @click="closeModal">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
        <h4 class="modal-title">
          <i class="fa fa-calendar-times-o" aria-hidden="true"></i>
          Deadline for "{{ file.name }}"
        </h4>
      </div>
      <div class="modal-body" v-loading="loading">
        <div class="form-group">
          <label>Deadline Date <span style="color: #c0392b;">*</span></label>
          <el-date-picker
            v-model="deadlineDate"
            type="date"
            placeholder="Select deadline date"
            style="width: 100%;"
            value-format="yyyy-MM-dd"
            :picker-options="datePickerOptions"
          ></el-date-picker>
        </div>
        <div class="form-group">
          <label>Label (optional)</label>
          <input
            v-model="label"
            type="text"
            class="form-control"
            placeholder="e.g. Contract expires, License renewal"
            maxlength="255"
          />
        </div>

        <!-- Reminder checkboxes -->
        <div class="form-group">
          <label>Send Reminders At</label>
          <div class="drive-deadline-reminders">
            <label class="drive-deadline-reminder-option">
              <input type="checkbox" v-model="remind14" /> 2 weeks before
            </label>
            <label class="drive-deadline-reminder-option">
              <input type="checkbox" v-model="remind7" /> 1 week before
            </label>
            <label class="drive-deadline-reminder-option">
              <input type="checkbox" v-model="remind3" /> 3 days before
            </label>
            <label class="drive-deadline-reminder-option">
              <input type="checkbox" v-model="remind0" /> Day of deadline
            </label>
          </div>
        </div>

        <!-- RSS feed toggle -->
        <div class="form-group">
          <label class="drive-deadline-reminder-option">
            <input type="checkbox" v-model="notifyRssFeed" />
            Also notify RSS feed group
          </label>
        </div>

        <!-- Multi-select employees -->
        <div class="form-group">
          <label>Who Gets Notified</label>
          <div class="drive-deadline-selected-list">
            <span
              v-for="emp in selectedEmployees"
              :key="emp.id"
              class="drive-deadline-chip"
            >
              {{ emp.first_name }} {{ emp.last_name }}
              <i class="fa fa-times" @click="removeEmployee(emp)"></i>
            </span>
          </div>
          <div class="drive-deadline-search-wrap">
            <input
              v-model="employeeSearch"
              type="text"
              class="form-control"
              placeholder="Search employees to add..."
              @input="searchEmployees"
            />
            <div v-if="employeeSearch && filteredResults.length > 0" class="drive-deadline-dropdown">
              <a
                v-for="emp in filteredResults"
                :key="emp.id"
                class="drive-deadline-dropdown-item"
                @click="addEmployee(emp)"
              >
                {{ emp.first_name }} {{ emp.last_name }} ({{ emp.email }})
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer text-center">
        <a
          v-if="hasExistingDeadline"
          href="javascript: void(0)"
          class="c-solid-btn c-solid-btn--red"
          @click="removeDeadline"
          style="float: left;"
        >
          <i class="fa fa-trash-o" aria-hidden="true"></i> Remove
        </a>
        <a
          href="javascript: void(0)"
          class="c-solid-btn c-solid-btn--green"
          @click="saveDeadline"
        >
          <i class="fa fa-check" aria-hidden="true"></i> Save
        </a>
        <a
          href="javascript: void(0)"
          class="c-solid-btn"
          @click="closeModal"
          style="margin-left: 10px;"
        >
          Cancel
        </a>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
import service from "../../services.js";

export default {
  name: "DriveDeadlineDialog",
  props: {
    file: { type: Object, required: true },
    apiHeaders: { type: Object, required: true },
  },
  data: function () {
    return {
      loading: false,
      deadlineDate: "",
      label: "",
      selectedEmployees: [],
      employeeSearch: "",
      searchResults: [],
      hasExistingDeadline: false,
      searchTimeout: null,
      notifyRssFeed: false,
      remind14: true,
      remind7: true,
      remind3: true,
      remind0: true,
      datePickerOptions: {
        disabledDate: function (date) {
          return date < new Date(new Date().setHours(0, 0, 0, 0));
        },
      },
    };
  },
  computed: {
    selectedIds: function () {
      return this.selectedEmployees.map(function (e) { return e.id; });
    },
    filteredResults: function () {
      var ids = this.selectedIds;
      return this.searchResults.filter(function (emp) {
        return ids.indexOf(emp.id) === -1;
      });
    },
  },
  mounted: function () {
    this.$modal.show("drive-deadline");
    this.loadDeadline();
  },
  methods: {
    loadDeadline: function () {
      var self = this;
      this.loading = true;

      service
        .get("drive/files/" + encodeURIComponent(this.file.id) + "/deadline", this.apiHeaders)
        .then(function (res) {
          self.loading = false;
          if (res.data.status_code === "1" && res.data.result) {
            self.deadlineDate = res.data.result.deadline_date || "";
            self.label = res.data.result.label || "";
            self.hasExistingDeadline = !!res.data.result.deadline_date;

            // Load RSS feed and reminder flags
            if (res.data.result.notify_rss_feed !== undefined) {
              self.notifyRssFeed = res.data.result.notify_rss_feed;
            }
            if (res.data.result.remind_14 !== undefined) {
              self.remind14 = res.data.result.remind_14;
            }
            if (res.data.result.remind_7 !== undefined) {
              self.remind7 = res.data.result.remind_7;
            }
            if (res.data.result.remind_3 !== undefined) {
              self.remind3 = res.data.result.remind_3;
            }
            if (res.data.result.remind_0 !== undefined) {
              self.remind0 = res.data.result.remind_0;
            }

            var notifyIds = res.data.result.notify_employee_ids || [];
            if (notifyIds.length > 0) {
              self.loadEmployeeInfo(notifyIds);
            }
          }
        })
        .catch(function () {
          self.loading = false;
        });
    },

    loadEmployeeInfo: function (employeeIds) {
      var self = this;
      service
        .get("drive/managers/eligible", this.apiHeaders)
        .then(function (res) {
          if (res.data.status_code === "1" && res.data.result) {
            var employees = res.data.result;
            var selected = [];
            for (var i = 0; i < employees.length; i++) {
              if (employeeIds.indexOf(employees[i].id) !== -1) {
                selected.push(employees[i]);
              }
            }
            self.selectedEmployees = selected;
          }
        })
        .catch(function () {
          // silent fail
        });
    },

    searchEmployees: function () {
      var self = this;
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      if (!this.employeeSearch || this.employeeSearch.length < 2) {
        this.searchResults = [];
        return;
      }

      this.searchTimeout = setTimeout(function () {
        service
          .get("drive/managers/eligible", self.apiHeaders)
          .then(function (res) {
            if (res.data.status_code === "1" && res.data.result) {
              var query = self.employeeSearch.toLowerCase();
              self.searchResults = res.data.result.filter(function (emp) {
                var name = (emp.first_name + " " + emp.last_name + " " + emp.email).toLowerCase();
                return name.indexOf(query) !== -1;
              });
            }
          })
          .catch(function () {
            self.searchResults = [];
          });
      }, 300);
    },

    addEmployee: function (emp) {
      this.selectedEmployees.push(emp);
      this.employeeSearch = "";
      this.searchResults = [];
    },

    removeEmployee: function (emp) {
      this.selectedEmployees = this.selectedEmployees.filter(function (e) {
        return e.id !== emp.id;
      });
    },

    saveDeadline: function () {
      if (!this.deadlineDate) {
        this.$message({ type: "warning", message: "Please select a deadline date" });
        return;
      }

      var self = this;
      this.loading = true;

      service
        .post(
          "drive/files/" + encodeURIComponent(this.file.id) + "/deadline",
          {
            deadline_date: this.deadlineDate,
            label: this.label || null,
            notify_employee_ids: this.selectedIds.length > 0 ? this.selectedIds : null,
            notify_rss_feed: this.notifyRssFeed,
            remind_14: this.remind14,
            remind_7: this.remind7,
            remind_3: this.remind3,
            remind_0: this.remind0,
          },
          this.apiHeaders
        )
        .then(function (res) {
          self.loading = false;
          if (res.data.status_code === "1") {
            self.$message({ type: "success", message: "Deadline saved" });
            self.$emit("deadline-set");
            self.closeModal();
          } else {
            self.$message({ type: "error", message: res.data.status_message || "Failed to save deadline" });
          }
        })
        .catch(function () {
          self.loading = false;
          self.$message({ type: "error", message: "Failed to save deadline" });
        });
    },

    removeDeadline: function () {
      var self = this;
      this.$confirm("Remove the deadline for this file?", "Remove Deadline", {
        confirmButtonText: "Remove",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(function () {
          self.loading = true;
          service
            .del("drive/files/" + encodeURIComponent(self.file.id) + "/deadline", self.apiHeaders)
            .then(function (res) {
              self.loading = false;
              if (res.data.status_code === "1") {
                self.$message({ type: "success", message: "Deadline removed" });
                self.$emit("deadline-removed");
                self.closeModal();
              } else {
                self.$message({ type: "error", message: res.data.status_message || "Failed to remove deadline" });
              }
            })
            .catch(function () {
              self.loading = false;
              self.$message({ type: "error", message: "Failed to remove deadline" });
            });
        })
        .catch(function () {
          // cancelled
        });
    },

    closeModal: function () {
      this.$modal.hide("drive-deadline");
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.drive-deadline-search-wrap {
  position: relative;
}
.drive-deadline-dropdown {
  position: absolute;
  z-index: 100;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.drive-deadline-dropdown-item {
  display: block;
  padding: 8px 12px;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  text-decoration: none;
}
.drive-deadline-dropdown-item:hover {
  background: #f0f5ff;
  color: #337ab7;
}
.drive-deadline-selected-list {
  margin-bottom: 8px;
}
.drive-deadline-chip {
  display: inline-block;
  padding: 4px 10px;
  margin: 2px 4px 2px 0;
  background: #f0f5ff;
  border-radius: 12px;
  font-size: 12px;
  color: #333;
}
.drive-deadline-chip i {
  cursor: pointer;
  margin-left: 6px;
  color: #999;
}
.drive-deadline-chip i:hover {
  color: #c0392b;
}
.drive-deadline-reminders {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
}
.drive-deadline-reminder-option {
  font-size: 13px;
  font-weight: normal;
  cursor: pointer;
}
.drive-deadline-reminder-option input {
  margin-right: 4px;
}
</style>
